import { useEffect, useState } from "react";
import { toast } from "sonner";
import { API_ENDPOINTS } from "../utils/urls";
import api from "../utils/api";

interface Props {
  setShowForm: (value: boolean) => void;
}

const AddAddons: React.FC<Props> = ({ setShowForm }) => {
  const [inventoryList, setInventoryList] = useState([
    {
      name: "",
      price: "",
      stock: 0,
      sku: "",
    },
  ]);

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.key === "Escape") setShowForm(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const addInventoryItem = () => {
    setInventoryList([
      ...inventoryList,
      {
        name: "",
        price: "",
        stock: 0,
        sku: "",
      },
    ]);
  };

  const removeInventoryItem = (index: number) => {
    const updated = [...inventoryList];
    updated.splice(index, 1);
    setInventoryList(updated);
  };

  const handleSubmit = async () => {
    try {
      await api.post(API_ENDPOINTS.INVENTORY.SAVE_ADDON_DATA, inventoryList);
      toast.success("Items added successfully!");
      setShowForm(false);
      setInventoryList([
        {
          name: "",
          price: "",
          stock: 0,
          sku: "",
        },
      ]);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error("Failed to save items");
      console.error(error);
    }
  };

  const handleInventoryInputChange = (
    e: any,
    invIndex: number,
    field: string
  ) => {
    const updated: any = [...inventoryList];
    updated[invIndex][field] = e.target.value;
    setInventoryList(updated);
  };

  return (
    <div className="mt-6">
      {inventoryList.map((item, i) => (
        <div key={i} className="mb-8 border p-4 rounded shadow-sm bg-gray-50">
          <div className="mb-2">
            <input
              type="text"
              placeholder="AddOn Name"
              value={item.name}
              onChange={(e) => handleInventoryInputChange(e, i, "name")}
              className="w-full border p-2 mb-2"
            />
            <input
              type="number"
              placeholder="Price"
              value={item.price}
              onChange={(e) => handleInventoryInputChange(e, i, "price")}
              className="w-full border p-2 mb-2"
            />

            <input
              type="number"
              placeholder="Stock"
              value={item.stock}
              onChange={(e) => handleInventoryInputChange(e, i, "stock")}
              className="w-full border p-2 mb-2"
            />
            <input
              type="text"
              placeholder="SKU"
              value={item.sku}
              onChange={(e) => handleInventoryInputChange(e, i, "sku")}
              className="w-full border p-2 mb-2"
            />

            {inventoryList.length > 1 && (
              <button
                className="text-red-500 text-sm"
                onClick={() => removeInventoryItem(i)}
              >
                Remove This Item
              </button>
            )}
          </div>
        </div>
      ))}

      <button
        onClick={addInventoryItem}
        className="bg-blue-200 text-blue-800 px-4 py-2 rounded mb-4"
      >
        + Add Another Item
      </button>

      <button
        onClick={handleSubmit}
        className="bg-blue-600 text-white px-6 py-2 rounded"
      >
        Save AddOn
      </button>
    </div>
  );
};

export default AddAddons;
